import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router';

// Types
import { BAFactorShapeType } from 'Shared/components/BehavioralPatternGraph/FactorShape.service';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useUser } from 'Shared/utils/hooks/use-user';

// Components
import { WpDrawerV2, WpDrawerV2Body } from 'Wpds/components/drawer';
import UserBaProfileSnapshot from './UserBaProfileSnapshot';

const UserBaProfileSnapshotRouteDrawer = () => {
  const location = useLocation();
  const state = location.state;
  const history = useHistory();

  const [isDrawerOpen, toggleIsDrawerOpen] = useToggle(false);
  const [userSlug, setUserSlug] = useState(null);
  const [shape, setShape] = useState<BAFactorShapeType>(null);

  const { user } = useUser({ slug: userSlug });

  const handleClose = () => {
    toggleIsDrawerOpen();
    setUserSlug(null);
    setShape(null);
  };

  useEffect(() => {
    if (state?.view === 'use-ba-snapshot') {
      toggleIsDrawerOpen();
      history.replace(location.pathname);
      setUserSlug(state.userSlug);
      setShape(state?.shape);
    }
  }, [state]);

  return (
    <WpDrawerV2 isOpen={isDrawerOpen} toggleIsOpen={handleClose}>
      <WpDrawerV2Body>
        {user && <UserBaProfileSnapshot user={user} shapeType={shape} inContainer={false} showConversationTips />}
      </WpDrawerV2Body>
    </WpDrawerV2>
  );
};

export default UserBaProfileSnapshotRouteDrawer;
